<script setup lang="ts">
import { useTestimony } from '@/composables/useTestimony';

const { testimony, averageRating, reviewCount, fetchTestimony } = useTestimony();

const props = defineProps({
  tour: {
    type: Object,
    required: true,
  },
});
  
// show more testimony (10 per page)
const itemsPerPage = 10;
const currentPage = ref(1);

const paginatedTestimony = computed(() => {
  return (testimony.value || []).slice(0, currentPage.value * itemsPerPage);
});

const showMore = () => {
  currentPage.value++;
};

onMounted(() => {
  fetchTestimony(props.tour.testimonies);
});


</script>

<template>
  <div>
    <div v-if="testimony?.length === 0"
      class="flex flex-col items-center justify-center gap-3 py-10 text-center text-gray-400">
      <p class="text-lg font-semibold">No Reviews Yet</p>
      <p class="text-sm">Reviews will appear here once users submit their feedback.</p>
    </div>
    <div v-else class="p-4 space-y-4 bg-white">
      <div>
        <div class="flex items-center gap-2 mt-1">
          <span class="text-3xl font-bold">{{ averageRating }}</span>
          <span class="text-sm text-gray-500">/5</span>
          <div class="flex gap-1 text-yellow-400">
            <img v-for="i in 5" :key="i" :src="i <= averageRating ? '/icons/star.svg' : '/images/star_outline.png'"
              alt="star" width="15" />
          </div>
        </div>

        <p class="text-gray-500 ">Based on {{ `(${reviewCount})` }} reviews</p>

      </div>

      <div v-for="review in paginatedTestimony" :key="review.id" class="p-4 transition-all duration-300 ease-in-out rounded-lg opacity-0 bg-gray-50 animate-fade-in">
        <div class="flex items-start justify-between">
          <div>
            <div class="flex items-center gap-2 mb-1">
              <div class="flex gap-1">
                <img v-for="i in review.rate" :key="i" src="public/icons/star.svg" alt="star" width="15">
              </div>
              <span class="text-sm font-semibold">{{ review.display_user }}</span>
            </div>
            <p class="text-sm text-gray-600 line-clamp-3">{{ review.content }}</p>
          </div>
        </div>
        <div class="flex items-center justify-end mt-2">
          <div class="relative">
            <img v-if="review.profile_photo" :src="review.profile_photo" alt="img"
              class="object-cover w-12 h-12 rounded-lg" />
            <img v-else src="/public/images/user_testimony.svg" alt="user" class="object-cover w-12 h-12 rounded-lg">
          </div>
        </div>
      </div>

      <div class="flex justify-center mt-4" v-if="testimony?.length > paginatedTestimony.length"
>
        <button @click="showMore"
          class="px-4 py-2 text-sm font-medium text-white rounded-md bg-primary hover:bg-primary/90">
          Show More Reviews
        </button>
      </div>

    </div>

  </div>
</template>

<style scoped>
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.4s ease forwards;
}

</style>